import { boolean, defineAction, enumerated, object, string } from '~/prix'
import monitorEmissorLegalEntityDistinctAttendanceImportAction from './monitorEmissorServiceAggregateImport.action.json'

const monitorEmissorLegalEntityDistinctAttendanceImportDefinition = defineAction({
  ...monitorEmissorLegalEntityDistinctAttendanceImportAction,
  input: object({
    file: string().isOptional(),
    step: enumerated({
      fetchUploadUrl: 'fetchUploadUrl',
      importFile: 'importFile',
    }),
    contentType: string().isOptional(),
  }),
  output: object({
    success: boolean(),
  }),
})

export default monitorEmissorLegalEntityDistinctAttendanceImportDefinition
